import React from "react";
import "./FooterItem.css";

export const FooterItem = ({scrollToSection, divSection, footerTitle, footerRefs, footerItems}) => {
    function handleFooterItem(Item) {
        if(Item === "Contact" || Item === "About" || divSection === "Services"){
            scrollToSection.current(Item);
        } else {
            console.log("Still need to fix this Item navigation");
        }
    }
    return (
            <div className="footer-tags">
                <p className="footer-header">{footerTitle}</p>
                <table>
                    {footerItems.map((elementName, index)=> (
                        divSection === "socialMedia" ? 
                        <a className="footer-links" target="_blank" key={index} href={footerRefs[index]}>{elementName} <br/></a> :
                        <tr className="footer-links" key={index} onClick={() => handleFooterItem(footerRefs?.[index])}>{elementName} <br/></tr>
                    ))}
                </table>
            </div>
    )
 }